//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum UserTaskStatus {
    Inactive = 0,
    WaitingAssignment = 1,
    Active = 2,
    Completed = 3,
    Returned = 4,
    Locked = 5,
    Submitting = 6,
}
